var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',[_c('h1',[_vm._v("Uh-oh . . .")]),_c('h3',[_vm._v("Server Error")]),_c('router-link',{attrs:{"to":{ name: 'home' }}},[_vm._v("Home page with menu")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }